<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.phoneNumber.$error }">
                <label for="phoneNumber">Teléfono</label>
                <input
                  type="text"
                  class="form-control"
                  id="phoneNumber"
                  aria-describedby="emailHelp"
                  v-model="item.phoneNumber"
                />
                <div class="error" v-if="!$v.item.phoneNumber.required">Campo requerido</div>
                <div class="error" v-if="!$v.item.phoneNumber.phone">Formato de número de teléfono no válido</div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group" :class="{ 'form-group--error': $v.item.email.$error }">
                <label for="email">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  v-model="item.email"
                />
                <div class="error" v-if="!$v.item.email.required">Campo requerido</div>
                <div class="error" v-if="!$v.item.email.email">Formato de email no válido</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.previousSchool.$error }">
                <label for="previousSchool">Escuela de procedencia</label>
                <input
                  type="email"
                  class="form-control"
                  id="previousSchool"
                  aria-describedby="emailHelp"
                  v-model="item.previousSchool"
                />
                <div class="error" v-if="!$v.item.previousSchool.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 ">
              <div class="form-group" :class="{ 'form-group--error': $v.item.schoolTypeSelected.$error }">
                  <div class="fg-line">
                      <label>¿Qué tipo de colegio es?</label>
                      <div class="select">
                          <select v-model="item.schoolTypeSelected" id="schoolTypeCode" name="schoolTypeSelected" class="form-control"> <!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="schoolType of schoolTypes" :key="schoolType.id" :value="schoolType">{{ schoolType.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.schoolTypeSelected.required">Campo requerido</div>
              </div>
            </div>  
             <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.graduationYear.$error }">
                <label for="phoneNumber">Año de finalización</label>
                <input
                  type="text"
                  class="form-control"
                  id="phoneNumber"
                  aria-describedby="emailHelp"
                  v-model="item.graduationYear"
                />
                <div class="error" v-if="!$v.item.graduationYear.required">Campo requerido</div>
                <div class="error" v-if="!$v.item.graduationYear.numeric">Solo se puede ingresar números</div>
                <div class="error" v-if="!$v.item.graduationYear.minLength">Se debe ingresar un mínimo de cuatro números</div>
                <div class="error" v-if="!$v.item.graduationYear.maxLength">Se debe ingresar un máximo de cuatro números</div>
                <div class="error" v-if="!$v.item.graduationYear.between">Se debe ingresar un año entre 1930 y {{new Date().getFullYear()}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1">
            <div class="form-group" :class="{ 'form-group--error': $v.item.notificationChannelSelected.$error }">
                <div class="fg-line">
                    <label>¿Cómo te notificaste de ésta carrera?</label>
                    <div class="select">
                        <select v-model="item.notificationChannelSelected" id="notificationChannelCode" name="notificationChannelSelected" class="form-control"> 
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="notificationChannel of notificationChannels" :key="notificationChannel.id" :value="notificationChannel">{{ notificationChannel.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.notificationChannelSelected.required">Campo requerido</div>
            </div>
            </div>
          </div>


        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
import { validationMixin } from 'vuelidate'
import { required, email, numeric,minLength,maxLength,between } from 'vuelidate/lib/validators'
import { phone } from '../../utils/validations'
import { mapGetters } from "vuex";


export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        phoneNumber: '',
        email: '',
        notificationChannelSelected:'',
        previousSchool: '',
        graduationYear:'',
        schoolTypeSelected:''
      },
      notificationChannels: null,
      schoolTypes : null,
    };
  },
    validations: {
      item: {
        phoneNumber: {
          required,
          phone
        },
        graduationYear: {
          required,
          numeric,
          minLength : minLength(4),
          maxLength : maxLength(4),
          between : between(1930,new Date().getFullYear())


          
        },
        email:{
          required,
          email
        },
        notificationChannelSelected:{
          required
        },
        schoolTypeSelected:{
          required
        },
        previousSchool:{
          required
        }
      }
  },  
  created() {
    this.$emit("can-continue", { value: true });
    this.getNotificationChannels();
    this.getSchoolTypes();
    
  },
  computed:{
    ...mapGetters(["getLevel"]),
    hasCourses(){
      return this.courses = this.$route.params.call.courses;
    }
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit('setStepThreeData', this.item)                    
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep(){
      if(!this.$v.$invalid){
        this.$emit("can-continue", { value: true });
      }
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit('setStepThreeData', this.item)                    
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods:{
    getNotificationChannels(){
      HTTPFront.get('/getNotificationChannels/'+this.getLevel)
      .then(res => {
        this.notificationChannels = res.data.rows;
      })
    },
    getSchoolTypes(){ 
      HTTPFront.get('/getSchoolTypes/'+this.getLevel)
      .then(res => {
        this.schoolTypes = res.data.rows;
      })       
    },
  }
};
</script>